import { firstValueFrom } from 'rxjs';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { RegistrationStore } from '../stores/registration.store';

export const RegisterGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const registrationStore = inject(RegistrationStore);

  const isAuthenticated = await firstValueFrom(auth.isAuthenticated$);
  if (isAuthenticated) {
    await router.navigateByUrl('/overview');
    return false;
  }

  // Initialize registration state from route
  registrationStore.initializeFromUrl(route);

  return true;
};
